module.exports = __webpack_public_path__ + "fonts/b69be43ef0f5c10ee024068b0516bdd8.woff2";